import { Ref } from 'react';

import { StaticPagesItemViewModel } from '@api/index';
import Markdown from '@components/utils/Markdown';
import { MarkdownTable } from '@components/utils/Markdown/styled';
import Typography from '@components/Typography';

import Announcement from './Announcement';
import { InfoContainer, SubHeader } from './styled';

type InfoCardProps = React.PropsWithChildren<
  Partial<StaticPagesItemViewModel> & { padding?: number }
>;
export const InfoCard = ({
  title,
  text,
  announcements = [],
  children,
  padding,
}: InfoCardProps) => (
  <InfoContainer padding={padding}>
    {title ? (
      <SubHeader>
        <Typography variant='Title4' color='D400' weight='Bold'>
          {title}
        </Typography>
      </SubHeader>
    ) : null}
    {announcements?.map(({ announcement }, index) =>
      announcement ? (
        <Announcement key={index} text={<Markdown text={announcement} />} />
      ) : null
    )}
    {text ? (
      <Markdown
        text={text}
        components={{
          table: ({ ref, ...rest }) => (
            <div style={{ overflowX: 'auto' }}>
              <MarkdownTable {...rest} ref={ref as Ref<HTMLTableElement>} />
            </div>
          ),
        }}
      />
    ) : null}
    {children}
  </InfoContainer>
);
